import { useState } from "react"

//Styles
import styles from "../../../../../styles/Form-Inputs.module.css"
import refEntityStyles from "../../../../../styles/referrals/ReferralEntityForm.module.css"

//PrimeReact
import { Chips } from "primereact/chips"

//Helpers
import FormikTreeInput from "../../../../../helpers/formikInputs/FormikTreeInput"

//Formik
import { useField } from "formik"
import { Dialog } from "primereact/dialog"
import { findServiceCategoryByKey } from "../../sharedFunctions"

export default function ReferralEntityFormLocationsCategories({
  serviceCategories,
  referralLocationIndex,
  isLoading,
}) {
  const fieldName = `referralLocations[${referralLocationIndex}].serviceTypeSelection`
  const maxCategoryChips = 15

  const [field, meta] = useField(fieldName)

  const [showDialog, setShowDialog] = useState(false)

  let selectedCategories = []
  let selectedCategoryIds = !!field.value
    ? Object.keys(field.value).filter((key) => field.value[key].checked)
    : []

  selectedCategoryIds.forEach((id) => {
    const category = findServiceCategoryByKey(id, serviceCategories)
    if (!!category) {
      selectedCategories.push(category.label)
    }
  })

  if (selectedCategories.length > maxCategoryChips) {
    const topTenCats = selectedCategories.slice(0, maxCategoryChips)
    topTenCats.push(
      `${
        selectedCategories.length - maxCategoryChips
      } additional referral services selected ...`
    )
    selectedCategories = topTenCats
  }

  return (
    <>
      <Dialog
        className={refEntityStyles.locationServiceCategoryDialog}
        visible={showDialog}
        onHide={() => {
          setShowDialog(false)
        }}
        header={"Service categories"}
      >
        <FormikTreeInput
          name={fieldName}
          label="Service categories"
          options={serviceCategories}
          helpText="This is the list of services available at this location"
          required={true}
          disabled={isLoading}
        />
        <button
          type="button"
          className="btn"
          onClick={() => {
            setShowDialog(false)
          }}
        >
          Close
        </button>
      </Dialog>
      <div className={styles.field}>
        <div className={refEntityStyles.locationServiceCategoryHeader}>
          <label>
            Service categories
            <span style={{ color: "red" }}> * </span>
            <div>
              <small style={{ color: "gray" }}>
                This is the list of services available at this location
              </small>
            </div>
          </label>
          <button
            type="button"
            className={`btn ${refEntityStyles.locationServiceCategoryButton}`}
            onClick={() => {
              setShowDialog(true)
            }}
          >
            Select service categories
          </button>
        </div>

        {meta.touched && meta.error ? (
          <div>
            <label id={`${fieldName}-error`} className={styles.errFieldMsg}>
              {meta.error}
            </label>
            <br />
          </div>
        ) : null}

        <div>
          <Chips
            className={refEntityStyles.locationServiceCategoryChips} //Note: Hardcoded to override hardcoded size in global.css for .p-chips .p-chips-multiple-container, should actually be 100%
            value={selectedCategories}
            readOnly={true}
            max={10}
          />
        </div>
      </div>
    </>
  )
}
